"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAutoScout24PriceRating = void 0;
var EAutoScout24PriceRating;
(function (EAutoScout24PriceRating) {
    EAutoScout24PriceRating["UNKNOWN"] = "0";
    EAutoScout24PriceRating["TOP"] = "1";
    EAutoScout24PriceRating["GOOD"] = "2";
    EAutoScout24PriceRating["FAIR"] = "3";
    EAutoScout24PriceRating["OKAY"] = "4";
    EAutoScout24PriceRating["EXPENSIVE"] = "5";
})(EAutoScout24PriceRating = exports.EAutoScout24PriceRating || (exports.EAutoScout24PriceRating = {}));
